import {Component, OnInit} from '@angular/core';
import {BmBankTransactionDomainBaseComponent} from '../bm-bank-transaction-domain-base.component';


@Component({
    selector: 'bm-bank-transaction-domain-side',
    templateUrl: 'bm-bank-transaction-domain-side.component.html',
    standalone: false
})
export class BmBankTransactionDomainSideComponent extends BmBankTransactionDomainBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
